import icons from './v1OperationIcons.json';
export { icons as v1OperationIcons };
export function operationIconKey(name='') {
  const value=name.toLowerCase();
  if(/powder|paint|coat/.test(value))return 'powder';
  if(/zinc|plat/.test(value))return 'zinc';
  if(/galv/.test(value))return 'hotGalv';
  if(/weld|assembl/.test(value))return 'welding';
  if(/pack|purchas/.test(value))return 'purchase';
  if(/etch|engrave|mark/.test(value))return 'etch';
  if(/deburr/.test(value))return 'deburr';
  return 'setup';
}
export const operationIcon = key => function V1OperationIcon({className}) {
  const icon=icons[key]||icons.setup;
  return <img src={icon.src} alt="" aria-hidden="true" data-operation-icon={key} className={className}/>;
};
